import * as pdfjsLib from "pdfjs-dist/build/pdf";

// Must match frontend/package.json pdfjs-dist version (worker from CDN avoids CRA worker bundling issues).
const PDFJS_VERSION = "2.5.207";
pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${PDFJS_VERSION}/pdf.worker.min.js`;

/**
 * Download a PDF from URL and render each page to a PNG data URL for the reconciliation viewer.
 * Requires the blob/storage origin to allow CORS GET from your app origin.
 */
async function PdfToImageConverter(URL) {
  if (!URL) {
    return [];
  }

  const response = await fetch(URL, { mode: "cors", credentials: "omit" });
  if (!response.ok) {
    throw new Error(`Failed to fetch PDF (${response.status})`);
  }

  const pdfData = new Uint8Array(await response.arrayBuffer());
  const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
  const imagesList = [];
  const canvas = document.createElement("canvas");

  for (let i = 1; i <= pdf.numPages; i += 1) {
    const page = await pdf.getPage(i);
    const viewport = page.getViewport({ scale: 2 });
    canvas.height = viewport.height;
    canvas.width = viewport.width;
    const ctx = canvas.getContext("2d");
    await page.render({
      canvasContext: ctx,
      viewport,
    }).promise;
    imagesList.push(canvas.toDataURL("image/png"));
  }

  return imagesList;
}

export default PdfToImageConverter;
